/** The title's tabs, in order. Every one is a real screen; `help` is its section of the user manual. */
export const TITLE_TABS: { to: string; label: string; end: boolean; help: string; only?: string }[] = [
  { to: '', label: 'Desk', end: true, help: 'desk' },
  { to: 'ideas', label: 'Ideas', end: false, help: 'ideas' },
  { to: 'pieces', label: 'Pieces', end: false, help: 'pieces' },
  { to: 'imports', label: 'Import', end: false, help: 'import' },
  { to: 'from-wordpress', label: 'From WordPress', end: false, help: 'from-wordpress' },
  { to: 'schedule', label: 'Schedule', end: false, help: 'schedule' },
  { to: 'weekly', label: 'Weekly package', end: false, help: 'weekly' },
  { to: 'live', label: 'Live', end: false, help: 'live' },
  { to: 'social', label: 'Social', end: false, help: 'social' },
  { to: 'topics', label: 'Topic pages', end: false, help: 'topics' },
  { to: 'tracks', label: 'Track Finder', end: false, help: 'tracks', only: 'rc_car_action' },
  { to: 'settings', label: 'Settings', end: false, help: 'settings' },
]

/** Tabs that belong to one title (`only`) are dropped for every other title. */
export function tabsForTitle<T extends { only?: string }>(tabs: T[], publicationSlug: string | null | undefined): T[] {
  return tabs.filter((t) => !t.only || t.only === publicationSlug)
}

/** The tab bar for one title: the common tabs less other titles' own (`only`). */
export function titleTabs(publicationSlug: string | null | undefined): typeof TITLE_TABS {
  return tabsForTitle(TITLE_TABS, publicationSlug)
}
